import React, { useContext, useEffect } from 'react'
import Select from 'react-select'
import { useDispatch, useSelector } from 'react-redux'
import { Controller, useFieldArray, useFormContext } from 'react-hook-form'
import CustomModal from '../customModal'
import { getAllCleanerNamesByRegion } from '../../redux/slices/cleanersSlice'
import { SpinnerContext } from '../../context/spinnerContext'
const CleanerDeleteModal = ({ isOpen, toggleModal, onHandleSubmit }) => {
  const dispatch = useDispatch()
  const { allCleanersNameByRegion, cleanerInfo } = useSelector(({ cleaners }) => cleaners)
  const { changeLoader } = useContext(SpinnerContext)
  const { control } = useFormContext()
  const { fields } = useFieldArray({
    control,
    name: 'cleanerProperty'
  })
  const propertiesList = fields?.[0]?.properties || []
  const propertySchedulesList = fields?.[1]?.propertySchedules || []
  useEffect(() => {
    const fetchData = async () => {
      changeLoader(true)
      try {
        dispatch(getAllCleanerNamesByRegion(cleanerInfo?.region_id))
      } catch (err) {
        console.error('Error fetching data:', err)
      } finally {
        changeLoader(false)
      }
    }
    fetchData()
  }, [])
  return (
    <CustomModal isOpen={isOpen} toggle={toggleModal} title={`Update Cleaner Details`} size="lg">
      {propertiesList?.length > 0 && (
        <div className="card-div-group">
          <div className="card-div-header">
            <h4 className="redional_admin_title">properties</h4>
          </div>
          <div className="row scrollable-container">
            {propertiesList.map((item, index) => {
              return (
                <div className="col-md-6" key={index}>
                  <div className="delete_data_style">
                    <div>{item?.properties_id?.property_name}</div>
                    <div className="form-group input_text border-remove dark_border_divs deletemodal_filed_width">
                      <Controller
                        name={`cleanerProperty[0].properties.${index}.cleaners_id`}
                        control={control}
                        render={({ field }) => (
                          <Select
                            {...field}
                            className={`react-selectcomponent form-control select-box-filed`}
                            getOptionLabel={(option) => `${option.first_name} ${option.last_name}`}
                            getOptionValue={(option) => `${option.cleaners_id}`}
                            options={allCleanersNameByRegion || []}
                            isSearchable={true}
                            placeholder={`Select Cleaner`}
                            classNamePrefix="select_kanakku"
                          />
                        )}
                      />
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      )}
      {propertySchedulesList?.length > 0 && (
        <div className="card-div-group">
          <div className="card-div-header">
            <h4 className="redional_admin_title">Property Schedules</h4>
          </div>
          <div className="row scrollable-container">
            {propertySchedulesList.map((item, index) => {
              return (
                <div className="col-md-6" key={index}>
                  <div style={{ marginBottom: '12px' }} className="delete_data_style">
                    <div>{item?.properties_id?.properties?.property_name}</div>
                    <div className="form-group input_text border-remove dark_border_divs deletemodal_filed_width">
                      <Controller
                        name={`cleanerProperty.[1].propertySchedules.${index}.cleaners_id`}
                        control={control}
                        render={({ field }) => (
                          <Select
                            {...field}
                            className={`react-selectcomponent form-control select-box-filed`}
                            getOptionLabel={(option) => `${option.first_name} ${option.last_name}`}
                            getOptionValue={(option) => `${option.cleaners_id}`}
                            options={allCleanersNameByRegion || []}
                            isSearchable={true}
                            placeholder={`Select Cleaner`}
                            classNamePrefix="select_kanakku"
                          />
                        )}
                      />
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      )}
      <div className="multi_btn_div modal-button-group">
        <button type="submit" className="btn btn-primary common-field-btn save_btn_size" onClick={onHandleSubmit}>
          {`Update`}
        </button>
      </div>
    </CustomModal>
  )
}

export default CleanerDeleteModal
